// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {BusinessLandingModuleLayout} from 'app_components/modules/admin/landings/businessLanding'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import LandingService from 'app_services/admin/landings/landingService'
// @end

// @import types
import { ILanding } from 'app_types/admin/landings/landingTypes'
// @end

// @ADD Component types
interface IBusinessLandingModuleProps {}
interface IBusinessLandingModuleState {
  landingInfo: ILanding | null
  status: null | 'loading' | 'error'
  loadingForm: null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BusinessLandingModule extends Component<IBusinessLandingModuleProps, IBusinessLandingModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private landingService: LandingService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBusinessLandingModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      landingInfo: null,
      loadingForm: null
    }

    this.permission = new PermissionService(this.moduleName)
    this.landingService = new LandingService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchLandingData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchLandingData = async () => {
    this.setState({ status: 'loading' })

    let httpParams: any = {
      slug: 'business'
    }

    let landing: ILanding | null = null

    const landingResponse = await this.landingService.fetchLandingData(httpParams)

    if (landingResponse) {
      landing = landingResponse
    }

    this.setState({
      landingInfo: landing,
      status: null
    })
  }

  onHandleGeneralInfoSubmit = async (formData: any) => {
    this.setState({loadingForm: 'loading'})

    const landingResponse = await this.landingService.saveGeneralInfo(
      {...formData, slug: 'business'},
      (this.state.landingInfo && this.state.landingInfo.landing?._id) ? `update/${this.state.landingInfo.landing._id}` : 'create'
    )

    this.setState({loadingForm: null})

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )
    }
  }

  onHandleSchedulingSubmit = async (data: any) => {
    if (data.status === 'success') {
      await this.fetchLandingData()
    }
  }

  render() {
    return(
      <BusinessLandingModuleLayout
        {...this.props}
        landingInfo={this.state.landingInfo}
        loadingForm={this.state.loadingForm}
        permission={this.permission}
        onHandleSchedulingSubmit={this.permission.check('permission:landings_business_scheduling', this.onHandleSchedulingSubmit)}
        onHandleGeneralInfoSubmit={this.permission.check('permission:landings_business_general_info', this.onHandleGeneralInfoSubmit)}
      />
    )
  }
}

export default connect(mapStatesToProps)(BusinessLandingModule)
